import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PayButton = ({ lookupKey, label, className = "", testid }) => {
  const [busy, setBusy] = useState(false);
  const pay = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, {
        lookup_key: lookupKey,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch {
      toast.error("Couldn't start checkout.", { description: "Please try again, or message us on WhatsApp." });
      setBusy(false);
    }
  };
  return (
    <button onClick={pay} disabled={busy} data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 font-semibold text-sm px-6 py-3 rounded-full transition-colors duration-200 disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-3.5 h-3.5" />}
      {busy ? "Redirecting…" : label}
    </button>
  );
};
